import { Button as AntDButton } from "antd";
import styled from "styled-components";

const Button = styled(AntDButton)`
  margin: 5px 0;
`;

export { Button };
